import React, { useEffect, useState } from 'react';

/**
 * Renders a fixed banner at the top of the page when the browser loses internet
 * connectivity. Disappears automatically once the connection is restored.
 */
function OfflineBanner() {
  const [offline, setOffline] = useState(() => !navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div className="offline-banner" role="alert" aria-live="assertive">
      <span aria-hidden="true">📡</span>
      <span>No internet connection — some features may be unavailable.</span>
    </div>
  );
}

export default OfflineBanner;
